import { capitalizeFirstLetter } from '../../Calendar/utils/capitalizeFirstLetter';

export function dashboardDataReportTransformer(data, type) {
  const formatted = Object.entries(data).map(([key, items]) => ({
    name: capitalizeFirstLetter(key),
    requestIds: items.map((item) => item.id),
  }));

  if (type === 'report') {
    return formatted;
  }

  return formatted.filter(
    (item) => item.name.toLowerCase() === type.toLowerCase()
  );
}
